export const environment = {
  env: 'dev',
  authIssuer: 'https://proxy.testing.eosc-federation.eu',
  authClientID: 'APP-26B4BE4A-657A-4295-99C8-431131F13F6F',
  apiUrl: 'https://api.dev-1.eosc.athenarc.gr',
  adminApiUrl: 'https://api.admin.dev-1.eosc.athenarc.gr',
  skipAuthInitialization: false,
  isErrorHandlingTestingPageIncluded: true,
  isTokenRetrievalPageIncluded: true,
  toolApiEndpoint: '/tools/admin/action/v1',
  entitlementsPrefix: 'urn:geant:eosc-federation.eu',
  helpdeskFormURL: 'https://eunode-helpdesk-stage.scc.kit.edu',
  helpdeskGeneralGroupID: 2,
  helpDeskLOT2GroupId: 26,
  helpDeskLOT3GroupId: 27,
  helpdeskCustomResourcesGroupID: 6,
  helpdeskCreditVouchersId: 2,
  aaiRegistrationURL: 'https://webapp.testing.eosc-federation.eu/sp_request',
};
